import type { SVGProps } from 'react';

export default function CloseCircleIcon(
  props: SVGProps<SVGSVGElement>,
): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      {...props}
    >
      <rect width="40" height="40" rx="20" fill="#FB3748" />
      <rect
        width="40"
        height="40"
        rx="20"
        fill="url(#paint0_linear_14204_64543)"
        fillOpacity="0.16"
      />
      <path
        d="M28.75 11.25L11.25 28.75M11.25 11.25L28.75 28.75"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_14204_64543"
          x1="20"
          y1="0"
          x2="20"
          y2="40"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </svg>
  );
}
